// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-sky-400 {
  color: rgb(56 189 248);
}

.progressDiv {
  margin: 20px auto;
  padding: 0;
  width: 90%;
  height: 30px;
  overflow: hidden;
  background: #e5e5e5;
  border-radius: 6px;
}

.barDiv {
  position: relative;
  float: left;
  min-width: 1%;
  height: 100%;
  background: cornflowerblue;
}

.percentDiv {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  font-family: tahoma, arial, helvetica;
  font-size: 12px;
  color: white;
}
.text-red {
  color: rgb(220 38 38);
  font-weight: 500;
}
.worklogs-list {
  border-left: 6px solid #336767;
  
}

.css-18bjr9h-MuiTableCell-root, .css-1w1rijm-MuiButtonBase-root-MuiButton-root, .css-s7wvpk-MuiChip-root, .css-ahj2mt-MuiTypography-root, .css-1e6y48t-MuiButtonBase-root-MuiButton-root {
  font-family: 'Inter'!important;font-weight: 300!important;
  
}

.tss-1vd39vz-MUIDataTableBodyCell-stackedCommon {
  font-size: 14px!important;
}

.MuiTablePagination-root {
  justify-content: flex-start !important;
}
.css-levciy-MuiTablePagination-displayedRows {
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  text-align: left; /* Align to the left */
}

.MuiTablePagination-toolbar {
  justify-content: flex-start; /* Align content to the left */
}

.css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected {
  color: #1976d2;
    color: #56677d;
}

.css-1aquho2-MuiTabs-indicator {
  position: absolute;
  height: 2px;
  bottom: 0;
  width: 100%;
  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  background-color: #56677d;
}

.MuiTablePagination-spacer {
  display: none; /* Remove extra spacer */
}

/* Apply a background color to the toolbar */
.MuiToolbar-root.MuiToolbar-gutters.MuiToolbar-regular {
  background-color: white!important; 
  padding: 10px;
  border-radius: 20px;
}
.MuiPaper-rounded {
  padding: 12px;
  border-radius: 100px;
}

.tss-1akey0g-MUIDataTableHeadCell-data {
  color: rgb(228, 228, 228) !important;
}

.MuiPaper-rounded {
  padding-left: 8px !important;
  padding-right: 8px !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

/* styles.css */
.navbar-notification {
  width: 1000px;
  height: 20px;
  padding: 2px;
}

.navbar-profile {
  width: 20px;
  height: 20px;
  padding: 2px;
}
.css-19kzrtu {
  background-color: white!important;
}
.css-1rwt2y5-MuiButtonBase-root-MuiButton-root {
  color: white!important;
  border-radius: 12px!important;
  background-color:  #56677d!important;
}


.css-rgkksm-MuiButtonBase-root-MuiTab-root.Mui-selected {
  color:white !important;
}
.css-2e41gn-MuiButtonBase-root-MuiTab-root.Mui-selected {
  color: white !important;
}

/* Add this to your CSS file */
.selected-button {
  background-color: #3b82f6!important; /* Blue color */
  color: white!important; /* White text */
}

/* Default button styling */
.btn {
  background-color: grey;
  color: black;
  font-weight: lighter;
  padding: 8px 16px;
  border-radius: 8px;
  border: 2px solid #064163;
  cursor: pointer;
}

/* When the button is selected, apply the red background */
.btn.selected {
  background-color: red;
  color: white;
}

.max-width-full-i{
  max-width: 100% !important;
}
.min-width-full{
  min-width: 100% !important;
}
.underline{
  text-decoration: underline;
}
.text-blue-600{
  color: #3182ce;
}
.border-red-500{
  border-color: rgb(239 68 68) !important;
}
button:focus,a:focus,input:focus {
  outline: none !important;
}

.border-dotted{
  border: 1px dashed;
}

.border-none{
  border: none !important;
}

.rounded-2xl{
  border-radius: 30px;
}

.h-300{
  height: 120px !important;
}

.zIGoD.is-disabled svg path {
  fill: #bdbdbd !important;
  color: #bdbdbd !important;
}

.cursor-disabled{
  cursor: not-allowed;
}

.bg-qt{
  background-color: #56677d;
}
.bg-qt-very-light{
  /* background-color: rgba(159, 172, 179, 0.2); */
  background-color: #56677d;
}
.bg-qt-light{
  background-color: #56677d;
}

.fill-qt{
  fill: #56677d;
}

.text-qt{
  color: #56677d;
}

.zIGoD.is-disabled svg {
  fill: #bdbdbd !important;
  color: #bdbdbd !important;
}

@media print {

  @page {
    size: A4;
    margin: 0;
  }
  body {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    print-color-adjust: exact;
    overflow: visible !important;
  }
  .MuiContainer-root {
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .MuiPaper-root {
    box-shadow: none !important;
    border: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  .MuiToolbar-root {
    display: none !important;
  }
  .MuiButtonBase-root {
    display: none !important;
  }
  .MuiTypography-root {
    font-size: 12px !important;
    line-height: 1.5 !important;
  }
  .MuiTableCell-root {
    padding: 0 !important;
    border: none !important;
  }
  .page-break {
    page-break-before: always;
  }
  .no-print {
    display: none !important;
  }
  .MuiTypography-root {
    font-size: 12px !important;
    line-height: 1.4 !important;
  }
  .page-break {
    page-break-before: always;
  }
  .no-print {
    display: none !important;
  }
  .MuiCollapse-root {
    display: block !important;
    visibility: visible !important;
    height: auto !important;
  }
  
  .MuiCollapse-hidden {
    display: none !important;
  }
}

 `, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,8BAA8B;;AAEhC;;AAEA;EACE,8BAA8B,CAAC,0BAA0B;;AAE3D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB,EAAE,sBAAsB;AAC1C;;AAEA;EACE,2BAA2B,EAAE,8BAA8B;AAC7D;;AAEA;EACE,cAAc;IAIZ,cAAc;AAHlB;;AAMA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EAEX,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;EACE,aAAa,EAAE,wBAAwB;AACzC;;AAEA,4CAA4C;AAC5C;EACE,iCAAiC;EACjC,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,iCAAiC;AACnC;AACA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,oCAAoC;AACtC;;;AAGA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,mCAAmC,EAAE,eAAe;EACpD,sBAAsB,EAAE,eAAe;AACzC;;AAEA,2BAA2B;AAC3B;EACE,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,gDAAgD;EAChD,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;;EAEE;IACE,QAAQ;IACR,SAAS;EACX;EACA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IAEtB,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;EACtB;EACA;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,qBAAqB;IACrB,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".text-sky-400 {\n  color: rgb(56 189 248);\n}\n\n.progressDiv {\n  margin: 20px auto;\n  padding: 0;\n  width: 90%;\n  height: 30px;\n  overflow: hidden;\n  background: #e5e5e5;\n  border-radius: 6px;\n}\n\n.barDiv {\n  position: relative;\n  float: left;\n  min-width: 1%;\n  height: 100%;\n  background: cornflowerblue;\n}\n\n.percentDiv {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  margin: 0;\n  font-family: tahoma, arial, helvetica;\n  font-size: 12px;\n  color: white;\n}\n.text-red {\n  color: rgb(220 38 38);\n  font-weight: 500;\n}\n.worklogs-list {\n  border-left: 6px solid #336767;\n  \n}\n\n.css-18bjr9h-MuiTableCell-root, .css-1w1rijm-MuiButtonBase-root-MuiButton-root, .css-s7wvpk-MuiChip-root, .css-ahj2mt-MuiTypography-root, .css-1e6y48t-MuiButtonBase-root-MuiButton-root {\n  font-family: 'Inter'!important;font-weight: 300!important;\n  \n}\n\n.tss-1vd39vz-MUIDataTableBodyCell-stackedCommon {\n  font-size: 14px!important;\n}\n\n.MuiTablePagination-root {\n  justify-content: flex-start !important;\n}\n.css-levciy-MuiTablePagination-displayedRows {\n  font-size: 1rem;\n  font-weight: bold;\n  color: #333;\n  text-align: left; /* Align to the left */\n}\n\n.MuiTablePagination-toolbar {\n  justify-content: flex-start; /* Align content to the left */\n}\n\n.css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected {\n  color: #1976d2;\n}\n\n.css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected {\n    color: #56677d;\n}\n\n.css-1aquho2-MuiTabs-indicator {\n  position: absolute;\n  height: 2px;\n  bottom: 0;\n  width: 100%;\n  -webkit-transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  background-color: #56677d;\n}\n\n.MuiTablePagination-spacer {\n  display: none; /* Remove extra spacer */\n}\n\n/* Apply a background color to the toolbar */\n.MuiToolbar-root.MuiToolbar-gutters.MuiToolbar-regular {\n  background-color: white!important; \n  padding: 10px;\n  border-radius: 20px;\n}\n.MuiPaper-rounded {\n  padding: 12px;\n  border-radius: 100px;\n}\n\n.tss-1akey0g-MUIDataTableHeadCell-data {\n  color: rgb(228, 228, 228) !important;\n}\n\n.MuiPaper-rounded {\n  padding-left: 8px !important;\n  padding-right: 8px !important;\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n}\n\n/* styles.css */\n.navbar-notification {\n  width: 1000px;\n  height: 20px;\n  padding: 2px;\n}\n\n.navbar-profile {\n  width: 20px;\n  height: 20px;\n  padding: 2px;\n}\n.css-19kzrtu {\n  background-color: white!important;\n}\n.css-1rwt2y5-MuiButtonBase-root-MuiButton-root {\n  color: white!important;\n  border-radius: 12px!important;\n  background-color:  #56677d!important;\n}\n\n\n.css-rgkksm-MuiButtonBase-root-MuiTab-root.Mui-selected {\n  color:white !important;\n}\n.css-2e41gn-MuiButtonBase-root-MuiTab-root.Mui-selected {\n  color: white !important;\n}\n\n/* Add this to your CSS file */\n.selected-button {\n  background-color: #3b82f6!important; /* Blue color */\n  color: white!important; /* White text */\n}\n\n/* Default button styling */\n.btn {\n  background-color: grey;\n  color: black;\n  font-weight: lighter;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: 2px solid #064163;\n  cursor: pointer;\n}\n\n/* When the button is selected, apply the red background */\n.btn.selected {\n  background-color: red;\n  color: white;\n}\n\n.max-width-full-i{\n  max-width: 100% !important;\n}\n.min-width-full{\n  min-width: 100% !important;\n}\n.underline{\n  text-decoration: underline;\n}\n.text-blue-600{\n  color: #3182ce;\n}\n.border-red-500{\n  border-color: rgb(239 68 68) !important;\n}\nbutton:focus,a:focus,input:focus {\n  outline: none !important;\n}\n\n.border-dotted{\n  border: 1px dashed;\n}\n\n.border-none{\n  border: none !important;\n}\n\n.rounded-2xl{\n  border-radius: 30px;\n}\n\n.h-300{\n  height: 120px !important;\n}\n\n.zIGoD.is-disabled svg path {\n  fill: #bdbdbd !important;\n  color: #bdbdbd !important;\n}\n\n.cursor-disabled{\n  cursor: not-allowed;\n}\n\n.bg-qt{\n  background-color: #56677d;\n}\n.bg-qt-very-light{\n  /* background-color: rgba(159, 172, 179, 0.2); */\n  background-color: #56677d;\n}\n.bg-qt-light{\n  background-color: #56677d;\n}\n\n.fill-qt{\n  fill: #56677d;\n}\n\n.text-qt{\n  color: #56677d;\n}\n\n.zIGoD.is-disabled svg {\n  fill: #bdbdbd !important;\n  color: #bdbdbd !important;\n}\n\n@media print {\n\n  @page {\n    size: A4;\n    margin: 0;\n  }\n  body {\n    margin: 0 !important;\n    padding: 0 !important;\n    width: 100% !important;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n    overflow: visible !important;\n  }\n  .MuiContainer-root {\n    width: 100% !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  .MuiPaper-root {\n    box-shadow: none !important;\n    border: none !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n  .MuiToolbar-root {\n    display: none !important;\n  }\n  .MuiButtonBase-root {\n    display: none !important;\n  }\n  .MuiTypography-root {\n    font-size: 12px !important;\n    line-height: 1.5 !important;\n  }\n  .MuiTableCell-root {\n    padding: 0 !important;\n    border: none !important;\n  }\n  .page-break {\n    page-break-before: always;\n  }\n  .no-print {\n    display: none !important;\n  }\n  .MuiTypography-root {\n    font-size: 12px !important;\n    line-height: 1.4 !important;\n  }\n  .page-break {\n    page-break-before: always;\n  }\n  .no-print {\n    display: none !important;\n  }\n  .MuiCollapse-root {\n    display: block !important;\n    visibility: visible !important;\n    height: auto !important;\n  }\n  \n  .MuiCollapse-hidden {\n    display: none !important;\n  }\n}\n\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
